import { getSdk, Sdk } from "@/__generated__/sdk";
import { Session } from "next-auth";
import { BaseGqlClient, BaseGqlClientType, BaseServerGqlClient } from "@/Providers/gqlClients/BaseGqlClient";

export class GqlClient {
  public gqlClient: Sdk;
  constructor(session: Session | null, baseConfig?: BaseGqlClientType, userHeaders?: Record<string, string | null>, useServer?: boolean) {
    const baseGql = useServer ? new BaseServerGqlClient(baseConfig) : new BaseGqlClient(baseConfig);
    this.gqlClient = getSdk(baseGql.client, async (action, operationName, operationType, variables) => {
      try {
        const headers: Record<string, string> = {
          ...(session && { Authorization: `Bearer ${session.token}` }),
          ...userHeaders,
        };
        return await action(headers);
      } catch (e) {
        // console.log({e});
        
        throw e;
      }
    });
  }
}
